import React, { useState, useEffect, useContext } from 'react';
import { Slider, Space, Typography, InputNumber, Switch } from 'antd';
import { ThemeContext } from 'pages/_app';
import { ObjectPosAudioPropsProps } from 'src/types';
import styles from './object-pos-audio-props.module.css';

export default function ObjectPosAudioProps({
  audio,
}: ObjectPosAudioPropsProps) {
  const { isDark } = useContext(ThemeContext);
  const [distance, setDistance] = useState<number>(0);
  const [volume, setVolume] = useState<number>(1);
  const [loop, setLoop] = useState<boolean>(false);
  const [autoplay, setAutoplay] = useState<boolean>(false);

  useEffect(() => {
    if (!audio) {
      return;
    }

    setDistance(audio.getRefDistance?.() || 0);
    setVolume(audio.getVolume?.() || 1);
    setLoop(audio.loop || false);
    setAutoplay(audio.autoplay || false);
  }, [audio]);

  const onChangeDistance = (val: number) => {
    const valueOut = val || 0;
    setDistance(valueOut);
    if (audio?.setRefDistance) {
      audio.setRefDistance(valueOut);
    }
  };

  const onChangeVolume = (val: number | null) => {
    const valueOut = val || 0;
    setVolume(valueOut);
    if (audio?.setVolume) {
      audio.setVolume(valueOut);
    }
  };

  const onChangeLoop = (checked: boolean) => {
    setLoop(checked);
    if (!audio) {
      return;
    }
    audio.loop = checked;
  };

  const onChangeAutoplay = (checked: boolean) => {
    setAutoplay(checked);
    if (!audio) {
      return;
    }
    audio.autoplay = checked;
  };

  if (!audio) {
    return null;
  }

  return (
    <div className={isDark ? styles.darkTheme : ''}>
      <Space direction='vertical' size='large' className={styles.container}>
        <div>
          <Typography.Text strong>Distance</Typography.Text>
          <Slider
            min={0}
            max={100}
            step={1}
            value={distance}
            onChange={onChangeDistance}
            style={{ marginTop: 8 }}
          />
        </div>

        <div>
          <Typography.Text strong>Volume</Typography.Text>
          <InputNumber
            size='small'
            min={0}
            max={1}
            step={0.1}
            value={volume}
            onChange={onChangeVolume}
            className={styles.inputNumber}
          />
        </div>

        <div>
          <Space className={styles.castShadowContainer}>
            <Typography.Text strong>Loop</Typography.Text>
            <Switch checked={loop} onChange={onChangeLoop} />
          </Space>
        </div>

        <div>
          <Space className={styles.castShadowContainer}>
            <Typography.Text strong>Autoplay</Typography.Text>
            <Switch checked={autoplay} onChange={onChangeAutoplay} />
          </Space>
        </div>
      </Space>
    </div>
  );
}
